import React, { useState, useEffect } from "react";
import "./ReportadasAdmin.css";
import Permiso from "../../router/Permiso";
import { View, Phone } from "lucide-react";
import { SaleService } from "../../services/SaleService";
import { useNavigate } from "react-router-dom";
import Input from "../../components/Input";
import { BarChart, Bar, XAxis, YAxis, Tooltip as RechartsTooltip,
  Legend as RechartsLegend, ResponsiveContainer } from 'recharts';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import RadialSeparators from "../../components/RadialSeparators";
import Select from "../../components/Select";
import Modal from "../../components/Modal";

const ReportadasAdmin = ({ token, refreshTrigger = 0 }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [codeSale, setCodeSale] = useState("");
  const [clientName, setClientName] = useState("");
  const [error, setError] = useState("");
  const [errorModal, setErrorModal] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [loading, setLoading] = useState(false);
  const [ventas, setVentas] = useState([]);
  const [productivityList, setProductivityList] = useState([]);
  const [productivityListValues, setProductivityListValues] = useState([]);
  const [percentStatistic, setPercentStatistic] = useState(0);
  const [monthSelected, setMonthSelected] = useState(new Date().getMonth() + 1);
  const [yearSelected, setYearSelected] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [modalOpened, setModalOpened] = useState(false);
  const navigate = useNavigate();
  const COLORS = ['#22b04c', '#4e79a7', '#f28e2b', '#e15759', '#76b7b2', '#59a14f', '#edc948', '#b07aa1'];

  useEffect(() => {
    fetchVentas();
    let tmpYears = [];
    for (let i = 2000; i <= new Date().getFullYear(); i++) {
      tmpYears.push({
        id: i,
        nombre: i
      });
    }
    setYears(tmpYears);
  }, [currentPage, refreshTrigger]);
  
  useEffect(() => {
    if (codeSale === "" && clientName === "") {
      fetchVentas();
    }
  }, [codeSale, clientName]);
  
  useEffect(() => {
    getStatistics();
  }, [yearSelected, monthSelected]);

  const getStatistics = async () => {
    const result = await SaleService.getStatistics({ token, yearSelected, monthSelected });
    let tmpData = [];
    result.statistic2.map((r) => {
      const name = r.name.split(' ');
      let shortName = "";
      name.map((n) => {
        shortName += n[0];
      });
      tmpData.push({
        [`${shortName}`]: r.count,
        name: r.name
      });
    });
    console.log(tmpData);
    setProductivityList(tmpData);
    setProductivityListValues(result.statistic2);

    if (result.statistic1.reported > 0) {
      setPercentStatistic(result.statistic1.reported / result.statistic1.count);
    }
  }

  const exportarExcel = async () => {
    //errorModal
    try {
      const filtros = {
        desde: startDate,
        hasta: endDate,
        dni: "",
        nombre: "",
        reportada: true
      };

      const blob = await SaleService.exportarVentasAvancesExcel(token, filtros);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "listado_reportadas.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
  } catch (error) {
      console.error("Error al exportar Excel:", error);
  }
};

  const FormModal = () => {
    return (
      <div className="">
        {errorModal && <div className="error-message">{errorModal}</div>}
        <Input title="Fecha de desde:" value={startDate} setValue={setStartDate} placeholder="" className="filtro-item" type="date" />
        <Input title="Fecha hasta:" value={endDate} setValue={setEndDate} placeholder="" className="filtro-item mt-10" type="date" />
      </div>
    );
  }

  const fetchVentas = async () => {
    setLoading(true);
    setError("");
    try {
      const { ventas, totalPaginas, totalRegistros } = await SaleService.fetchVentasAvances({
        token,
        pagina: currentPage,
        pageSize: 20,
        desde: "",
        hasta: "",
        dni: codeSale,
        nombre: clientName,
      });

      setVentas(ventas);
      setTotalPages(totalPaginas);
      setTotalRegistros(totalRegistros);
    } catch (err) {
      setError("Error al cargar las ventas");
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ventas-admin-content">
      <div className="ventas-admin-tab-content">

        <div className="flex w-full">
          <div className="w-20">
            <div className="ventas-admin-subtitle">
              Reportadas
            </div>
            <p>Gestión Reportadas</p>

            <div className="flex">
              <Select title="Año" value={yearSelected} setValue={setYearSelected} options={years} className="w-30"/>
              <Select title="Mes" value={monthSelected} setValue={setMonthSelected} options={[
                {
                  id: 1,
                  nombre: 'Enero'
                },
                {
                  id: 2,
                  nombre: 'Febrero'
                },
                {
                  id: 3,
                  nombre: 'Marzo'
                },
                {
                  id: 4,
                  nombre: 'Abril'
                },
                {
                  id: 5,
                  nombre: 'Mayo'
                },
                {
                  id: 6,
                  nombre: 'Junio'
                },
                {
                  id: 7,
                  nombre: 'Julio'
                },
                {
                  id: 8,
                  nombre: 'Agosto'
                },
                {
                  id: 9,
                  nombre: 'Septiembre'
                },
                {
                  id: 10,
                  nombre: 'Octubre'
                },
                {
                  id: 11,
                  nombre: 'Noviembre'
                },
                {
                  id: 12,
                  nombre: 'Diciembre'
                },
              ]} className="ml-5 w-40"/>
            </div>

          </div>
          <div className="w-20">
            <div className="ventas-admin-subtitle pb-10">
              Avance de Gestión
            </div>
            <CircularProgressbarWithChildren
              value={percentStatistic}
              text={`${percentStatistic}%`}
              strokeWidth={10}
              styles={buildStyles({
                strokeLinecap: "butt",
                pathColor: "#8a6fcb",
                textColor: "black"
              })}
            >
              <RadialSeparators
                count={12}
                style={{
                  background: "#fff",
                  width: "2px",
                  height: `${10}%`
                }}
              />
            </CircularProgressbarWithChildren>
          </div>
          <div className="w-40">
            <div className="ventas-admin-subtitle pb-10">
              Productividad
            </div>
            {
              productivityList.length > 0 && (
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={productivityList}>
                    <XAxis dataKey="name" />
                    <YAxis />
                    <RechartsTooltip />
                    <RechartsLegend />
                    {
                      productivityListValues.map((v, index) => {
                        const name = v.name.split(' '); //fill="#22b04c"
                        let shortName = "";
                        name.map((n) => {
                          shortName += n[0];
                        });
                        return (
                          <Bar key={v.id} dataKey={shortName} fill={COLORS[index % COLORS.length]} />
                        );
                      })
                    }
                  </BarChart>
                </ResponsiveContainer>
              )
            }
          </div>
        </div>

        <div className="ventas-table-header">
            <h2 className="ventas-table-title">Lista de reportadas </h2>
            <div className="productos-actions">
                <Permiso permiso="export_reported">
                    <button onClick={() => setModalOpened(true)} className="btn-exportar">
                        Exportar a Excel
                    </button>
                </Permiso>
            </div>
        </div>

        <div className="usuarios-filtros w-60 mt-10">
          <Input title="Código de venta:" value={codeSale} setValue={setCodeSale} placeholder="Ingrese número" className="filtro-item" />
          <Input title="Buscar por nombre:" value={clientName} setValue={setClientName} placeholder="Ingrese nombre del cliente" className="filtro-item" />
          <div className="filtro-item">
            <button onClick={() => {
              if (codeSale !== "" || clientName !== "") {
                fetchVentas();
              }
            }} className="btn-filtrar">
              Buscar
            </button>
          </div>
        </div>

        {error && <div className="error-message">{error}</div>}

        {loading ? (
          <div className="loading">Cargando ventas...</div>
        ) : (
          <>
            <div className="ventas-table-wrapper">
              <table className="ventas-table">
                <thead>
                  <tr>
                    <th>Codigo</th>
                    <th>Vendedor</th>
                    <th>Cliente</th>
                    <th>F. Venta</th>
                    <th>F. Gestión</th>
                    <th>Estado</th>
                    <th>Temático</th>
                    <th>Llamada</th>
                    <th>Instalado</th>
                    <th>Back</th>
                    <th># Contac</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {ventas.map((venta) => {
                    const following = typeof venta.seguimiento.id != "undefined";
                    return (
                      <tr key={venta.id}>
                        <td>{venta.cod_cliente}</td>
                        <td>
                          {venta.nombre_vendedor} {venta.apellido_vendedor}
                        </td>
                        <td>
                          {venta.nombre_cliente}
                        </td>
                        <td>{new Date(venta.fecha_precliente).toLocaleDateString()}</td>
                        <td>{following ? new Date(venta.seguimiento.fecha).toLocaleDateString() : ''}</td>
                        <td>{following ? venta.seguimiento.estado_servicio : venta.estado_servicio}</td>
                        <td>{following ? venta.seguimiento.tematico : ''}</td>
                        <td>{following ? (venta.seguimiento.llamada === 1 ? 'No contacto' : 'Contacto Efectivo') : ''}</td>
                        <td>{following ? (venta.seguimiento.instalado === 1 ? 'Si' : 'No') : ''}</td>
                        <td>{following ? venta.seguimiento.nombre_responsable : ''}</td>
                        <td>{following ? venta.seguimiento.index : ''}</td>
                        <td className="ventas-acciones">
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate(`/admin/reportadas/registrar/${venta.id}/only`)}
                          >
                            <View size={20} />
                          </span>
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              navigate(`/admin/reportadas/registrar/${venta.id}`);
                            }}
                          >
                            <Phone size={20} />
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <span style={{ marginLeft: "12px", fontSize: "14px", color: "#555" }}>
              {" "}
              Total de registros: {totalRegistros}{" "}
            </span>
            {/* Paginación */}
            <div className="pagination">
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Anterior
              </button>
              <span>
                Página {currentPage} de {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Siguiente
              </button>
            </div>
          </>
        )}
      </div>
      <Modal
        show={modalOpened}
        title={"Seleccione rango de fechas para exportar"}
        onClickButtonAction={exportarExcel}
        textButtonAction={"Exportar"}
        onClose={() => setModalOpened(false)}
        content={<FormModal />}
      />
    </div>
  );
};

export default ReportadasAdmin;
